import React from 'react';
import {ArrowLeft} from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  // Meta tags (título, canonical, noindex) são geridas pelo DynamicHead
  
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <Link to="/" className="inline-flex items-center text-green-700 hover:text-green-800 mb-8 transition-colors">
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar ao Site
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 mb-2">Política de Privacidade</h1>
        <p className="text-sm text-gray-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-PT')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          {/* Secção 1 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Identificação do Responsável</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="mb-2"><strong>Nome da Empresa:</strong> Pinhacorada</p>
              <p className="mb-2"><strong>Localização:</strong> Mortágua, Portugal</p>
              <p className="mb-2"><strong>Email:</strong> pinhacorada@gmail.com</p>
              <p><strong>Telefone:</strong> 965 812 210</p>
            </div>
          </section>

          {/* Secção 2 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Dados Pessoais Recolhidos</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada recolhe e processa os seguintes dados pessoais através do nosso website:
            </p>
            <div className="bg-green-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">Formulário de Contacto:</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Nome</li>
                <li>Endereço de email</li>
                <li>Número de telefone/contacto</li>
                <li>Mensagem enviada</li>
              </ul>
            </div>
            <p className="text-gray-700 mt-4">
              Não recolhemos dados sensíveis nem informações de menores sem consentimento parental.
            </p>
          </section>

          {/* Secção 3 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Finalidade do Tratamento de Dados</h2>
            <p className="text-gray-700 mb-4">Os seus dados pessoais são utilizados exclusivamente para:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Responder aos seus pedidos de informação ou esclarecimento</li>
              <li>Elaborar e enviar orçamentos personalizados</li>
              <li>Estabelecer contacto para prestação dos nossos serviços</li>
              <li>Cumprir obrigações legais e contratuais</li>
            </ul>
            <p className="text-gray-700 mt-4">
              <strong>Não partilhamos, vendemos ou alugamos os seus dados pessoais a terceiros para fins comerciais.</strong>
            </p>
          </section>

          {/* Secção 4 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Base Legal (RGPD)</h2>
            <p className="text-gray-700 mb-4">
              O tratamento dos seus dados pessoais fundamenta-se nas seguintes bases legais, de acordo com o Regulamento Geral sobre a Proteção de Dados (RGPD):
            </p>
            <div className="bg-gray-50 p-6 rounded-lg space-y-3">
              <p className="text-gray-700">
                <strong>• Consentimento:</strong> Ao preencher e submeter o formulário de contacto, está a dar o seu consentimento expresso para o tratamento dos dados fornecidos.
              </p>
              <p className="text-gray-700">
                <strong>• Execução de contrato:</strong> O tratamento é necessário para a execução de medidas pré-contratuais ou contratuais solicitadas pelo titular dos dados.
              </p>
            </div>
          </section>

          {/* Secção 5 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Prazo de Conservação dos Dados</h2>
            <p className="text-gray-700 mb-4">
              Os dados pessoais recolhidos são conservados de acordo com os seguintes critérios:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Durante <strong>2 anos</strong> após o último contacto ou interação</li>
              <li>Até à revogação do consentimento por parte do titular dos dados</li>
              <li>Pelo período exigido por lei para cumprimento de obrigações legais</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Após este período, os dados serão eliminados de forma segura e irreversível.
            </p>
          </section>

          {/* Secção 6 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Direitos do Titular dos Dados</h2>
            <p className="text-gray-700 mb-4">
              Nos termos do RGPD, tem os seguintes direitos relativamente aos seus dados pessoais:
            </p>
            <div className="bg-green-50 p-6 rounded-lg space-y-3">
              <p className="text-gray-700"><strong>✓ Direito de Acesso:</strong> Pode solicitar informações sobre os dados que detemos sobre si</p>
              <p className="text-gray-700"><strong>✓ Direito de Retificação:</strong> Pode solicitar a correção de dados incorretos ou incompletos</p>
              <p className="text-gray-700"><strong>✓ Direito ao Apagamento:</strong> Pode solicitar a eliminação dos seus dados pessoais ("direito ao esquecimento")</p>
              <p className="text-gray-700"><strong>✓ Direito à Portabilidade:</strong> Pode solicitar a transferência dos seus dados noutro formato</p>
              <p className="text-gray-700"><strong>✓ Direito de Oposição:</strong> Pode opor-se ao tratamento dos seus dados em determinadas circunstâncias</p>
              <p className="text-gray-700"><strong>✓ Direito de Limitação:</strong> Pode solicitar a limitação do tratamento dos seus dados</p>
            </div>
            <p className="text-gray-700 mt-6">
              <strong>Para exercer qualquer um destes direitos, contacte-nos através de:</strong>
            </p>
            <div className="bg-gray-900 text-white p-4 rounded-lg mt-3">
              <p>📧 Email: <a href="mailto:pinhacorada@gmail.com" className="underline hover:text-green-400">pinhacorada@gmail.com</a></p>
              <p className="mt-2">📞 Telefone: 965 812 210</p>
            </div>
          </section>

          {/* Secção 7 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Partilha de Dados com Terceiros</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada pode partilhar os seus dados pessoais com os seguintes prestadores de serviços, exclusivamente para fins operacionais:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Serviços de email e comunicação (para envio de respostas e orçamentos)</li>
              <li>Plataforma de hosting do website</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Todos os prestadores de serviços estão contratualmente obrigados a proteger os seus dados e a utilizá-los apenas para os fins especificados.
            </p>
          </section>

          {/* Secção 8 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Segurança dos Dados</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada implementa medidas técnicas e organizacionais adequadas para proteger os seus dados pessoais contra:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Acesso não autorizado</li>
              <li>Destruição acidental ou ilícita</li>
              <li>Perda, alteração ou divulgação indevida</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Utilizamos encriptação SSL/TLS para proteger a transmissão de dados através do nosso website.
            </p>
          </section>

          {/* Secção 9 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Cookies</h2>
            <p className="text-gray-700 mb-4">
              O nosso website utiliza cookies essenciais para garantir o funcionamento correto da plataforma. 
              Não utilizamos cookies de marketing ou tracking sem o seu consentimento explícito.
            </p>
          </section>

          {/* Secção 10 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Alterações à Política de Privacidade</h2>
            <p className="text-gray-700">
              A Pinhacorada reserva-se o direito de atualizar esta Política de Privacidade periodicamente. 
              Quaisquer alterações serão publicadas nesta página com a data de atualização revista. 
              Recomendamos que consulte esta página regularmente para se manter informado.
            </p>
          </section>

          {/* Secção 11 */}
          <section className="border-t pt-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Questões e Reclamações</h2>
            <p className="text-gray-700 mb-4">
              Se tiver questões sobre esta Política de Privacidade ou sobre o tratamento dos seus dados pessoais, 
              contacte-nos através dos meios indicados acima.
            </p>
            <p className="text-gray-700">
              Tem também o direito de apresentar reclamação junto da <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong> 
              se considerar que os seus direitos não estão a ser respeitados:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mt-3">
              <p className="text-gray-700">🏛️ <strong>CNPD</strong> - Comissão Nacional de Proteção de Dados</p>
              <p className="text-gray-700 mt-1">Website: <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer" className="text-green-700 underline hover:text-green-800">www.cnpd.pt</a></p>
            </div>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t">
          <Link to="/" className="inline-flex items-center text-green-700 hover:text-green-800 transition-colors font-semibold">
            <ArrowLeft className="h-5 w-5 mr-2" />
            Voltar ao Site
          </Link>
        </div>
      </div>
    </div>
  );
}